<template>
  <div class="m1">
    <div class="hd ">
      <div class="h1">
        告警信息
      </div>
      <div class="back" @click="back()">
      	返回
      </div>
    </div>
 <sbxq :hjjc_current="hjjc_current" :sbId="sbId"></sbxq>
  </div>
</template>

<script>
  import sbxq from '/src/views/SBGL/sbxxglDetail2.vue'
  export default {
    name: 'gsgly',
    components: {

      sbxq
    },
    data() {
      return {
        list: [{
            name: '在线检测',
            qr: false
          },
          {
            name: '项目管理',
            qr: false
          }, {
            name: '设备管理',
            qr: false
          }, {
            name: '施工管理',
            qr: false
          }, {
            name: '告警管理',
            qr: false
          }, {
            name: '账号管理',
            qr: false
          }
        ],
        value: true,
        currentPage4: 1,
        obj: {
          "page": 1,
          "size": 10
        },
        Data: [],
        total:null,
        sbId:null,
        hjjc_current:null
      }
    },
    created() {
      console.log(this.$route.query.id,this.$route.query.type,'this.$route.query.id！！！');
      this.sbId = parseInt(this.$route.query.id)
      this.hjjc_current = parseInt(this.$route.query.type)
      this.info()
    },
    methods: {
		back() {
			this.$router.go(-1); //返回上一层
		},
      del(id) {
        console.log(id);
        this.$ajax('delsgry', 'delete', id).then(res => {
          console.log(res);
          this.info()
          this.$message({
            type: 'success',
            message: '删除成功'
          });
        })
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.obj.size = val
        this.info()

      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.obj.page = val
        this.info()
      },
      info() {
        this.$ajax('gjxx', 'post', this.obj).then(res => {
          console.log(res);
          this.Data = res.data.records
          this.total = res.data.total
          // this.Data.forEach(item => {
          //   if (item.state == 0) {
          //     this.$set(item, 'KG', true)
          //   } else {
          //     this.$set(item, 'KG', false)
          //   }
          // })
        })
      }
    },

  }
</script>

<style lang="scss" scoped>
  .m1 {
    position: relative;
    color: #FFFFFF;
    margin: 1rem 0 0 1rem;
    width: 156.6rem;

    // height: 59.4rem;

    .hd {
      position: relative;
      // width: 100%;
      width: 156.6rem;
      height: 5rem;


      .h1 {
        display: inline-block;
        width: 11.5rem;
        height: 5rem;
        line-height: 5rem;
        padding-left: 1rem;
        font-size: 1.8rem;
      }

      .h2 {
        position: absolute;
        top: 1rem;
        right: 2rem;
        width: 11.5rem;
        height: 4.2rem;
        background-color: rgba(43, 201, 222, 1);
        line-height: 4.2rem;
        text-align: center;
        border-radius: .5rem;
      }
    }

    .lb {
      position: relative;
      // border: 1px solid #2BDEC9;
      margin-top: 1rem;
      font-size: 1.4rem;
      // overflow: auto;

      .hd {
        width: 100%;
        height: 3.6rem;
        line-height: 3.6rem;
        // padding-left: 1rem;
        font-size: 1.4rem;

        // border-bottom: 1px solid #2BDEC9;
        .hd_1 {
          display: inline-block;
          width: 5%;
          height: 4.2rem;
          line-height: 4.2rem;
          text-align: center;
          margin-right: .5%;
          background-color: rgba(43, 201, 222, 0.6);
        }

        .hd_2 {
          display: inline-block;
          width: 19%;
          height: 4.2rem;
          line-height: 4.2rem;
          background-color: rgba(43, 201, 222, 0.6);
          margin-right: .5rem;
        }

        .zh {
          margin-left: 1rem;
          display: inline-block;
          width: 16.8rem;
          overflow: hidden;
        }
      }

      .hd:last-child {
        // border-bottom: none;
      }

      .qx {
        position: absolute;
        top: .1rem;
        left: 50rem;
        display: inline-block;

        .lst {
          display: inline-block;
          width: 6.6rem;
          height: 2.6rem;
          line-height: 2.6rem;
          background-color: rgba(43, 201, 222, 0.6);
          text-align: center;
          border-radius: .3rem;
          margin-right: 1rem;
        }
      }

      .xg {
        position: absolute;
        top: .5rem;
        right: 2rem;
        width: 27rem;
        height: 2.6rem;
        line-height: 2.6rem;

        .gg {
          display: inline-block;
          width: 6.6rem;
          height: 2.6rem;
          line-height: 2.6rem;
          text-align: center;
          background-color: rgba(28, 184, 184, 1);
          border-radius: .4rem;
          margin-left: 1rem;
        }
      }
    }

    .main {
      position: relative;
      width: 100%;
      // height: 4.2rem;
      margin-top: .5rem;

      .m_1 {
        display: inline-block;
        width: 5%;
        height: 4.2rem;
        line-height: 4.2rem;
        text-align: center;
        margin-right: .5%;
        border: 1px solid rgba(43, 201, 222, 0.6);
        box-sizing: border-box;
      }

      .m_2 {
        display: inline-block;
        width: 19%;
        height: 4.2rem;
        line-height: 4.2rem;
        border: 1px solid rgba(43, 201, 222, 0.6);
        box-sizing: border-box;
        margin-right: .5rem;
      }

      .m_3 {
        position: relative;
        box-sizing: border-box;
        float: right;
        width: 94.5%;
        height: 4.2rem;
        border: 1px solid rgba(43, 201, 222, 0.6);
        box-sizing: border-box;
        margin-top: .5rem;
        line-height: 4.2rem;

        .zh {
          margin-left: 1rem;
          display: inline-block;
          width: 16.8rem;
          overflow: hidden;
        }

        .qx {
          position: absolute;
          top: .1rem;
          left: 50rem;
          display: inline-block;

          .lst {
            display: inline-block;
            width: 6.6rem;
            height: 2.6rem;
            line-height: 2.6rem;
            background-color: rgba(43, 201, 222, 0.6);
            text-align: center;
            border-radius: .3rem;
            margin-right: 1rem;
          }
        }

        .xg {
          position: absolute;
          top: .5rem;
          right: 2rem;
          width: 27rem;
          height: 2.6rem;
          line-height: 2.6rem;

          .gg {
            display: inline-block;
            width: 6.6rem;
            height: 2.6rem;
            line-height: 2.6rem;
            text-align: center;
            background-color: rgba(28, 184, 184, 1);
            border-radius: .4rem;
            margin-left: 1rem;
          }
        }
      }

      .m_3:last-child {
        margin-bottom: 1rem;
      }
    }
  }
  .back {
  	position: absolute;
  	top: 1rem;
  	right: 2rem;
  	border: 1px solid #1CB8B8;
  	border-radius: 0.5rem;
  	width: 6.7rem;
  	height: 3.8rem;
  	line-height: 3.8rem;
  	text-align: center;
  	color: rgba(28, 184, 184, 1);
  	font-size: 1.4rem;
  	margin-right: 2rem;
  	cursor: pointer;
  }
</style>
